export const WORKSPACE_SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])$/

export const validateWorkspaceSlug = (slug: string): string | null => {
  const trimmed = slug.trim()
  if (!trimmed) return 'Enter a workspace ID.'
  if (trimmed !== slug) return 'Workspace ID cannot start or end with spaces.'
  if (/[A-Z]/.test(trimmed)) return 'Use lowercase letters only. Uppercase is not allowed.'
  if (trimmed.length < 3 || trimmed.length > 40) return 'Workspace ID must be 3-40 characters.'
  if (!WORKSPACE_SLUG_PATTERN.test(trimmed)) {
    return 'Use lowercase letters, numbers, and hyphens. Start and end with a letter or number.'
  }
  return null
}

export const suggestWorkspaceSlug = (name: string) => {
  const base = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '')

  return base.length >= 3 ? base : ''
}
